import MaterialIconsReact from "material-icons-react";
import React, { useEffect, useRef, useState } from "react";
import { debounce } from "../helpers/Utils";
import styles from "./SearchInput.module.css";

function SearchInput(props) {
  const [filteredResults, setFilteredResults] = useState([]);
  const [showSuggestion, setShowSuggestion] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (props.focus) {
      inputRef.current.focus();
    }
  }, [props.focus])

  const onSearch = async function(value) {
    if (value === '') {
      setFilteredResults([]);
      return;
    }
    let searchResults = await props.onSearch(value);
    setShowSuggestion(true);
    if (typeof searchResults.message != 'string') {
      setFilteredResults(searchResults.message);
    }
  }

  const optimizedFn = debounce(onSearch);

  const onItemSelection = function(result, index) {
    clearSearch();
    props.onItemSelection(result,index)
  }

  const clearSearch = function() {
    setShowSuggestion(false);
    inputRef.current.value = '';
  }

  return (
    <span className={styles.inputContainer}>
      <div
        onClick={clearSearch}
        style={{
          display: showSuggestion ? "block" : "none",
          width: "200vw",
          height: "200vh",
          backgroundColor: "transparent",
          position: "fixed",
          zIndex: 0,
          top: 0,
          left: 0
        }}
      />
      {props.icon !== false && <div className={styles.iconContainer}>
        <MaterialIconsReact icon="search" size={20}></MaterialIconsReact>
      </div>}
      <div style={{position: 'relative'}}>
        <input 
          type='text' 
          autoComplete="off" 
          placeholder={props.placeholder} 
          className={styles.input + ' ft-14'} 
          onChange={(e) => optimizedFn(e.target.value)}
          style={{...props.style, borderRadius: props.icon === false ? '4px' : '0px'}}
          data-testid="searchInput"
          ref={inputRef} autoFocus={props.autoFocus} />
        {(filteredResults?.length || 0) > 0 && showSuggestion && <ul className={styles.suggestions}>
          {filteredResults.map((result, index) => {
            return (
              <li data-testid={'list'+index} key={index} onClick={() => onItemSelection(result, index)}>
                {result.item_name}
              </li>
            );
          })}
        </ul>}
      </div>
    </span>
  );
}

export default SearchInput;